/**
 * Platform-agnostic Diff Highlighting Module
 *
 * Exports diff highlighter for both Excel and Google Sheets.
 * Use the useDiffHighlighter() hook in components to get the correct implementation.
 */

import { useMemo } from 'react'
import { usePlatform } from '../platform'
import { diffHighlighter as diffHighlighterExcel } from './highlight-excel'
import { diffHighlighter as diffHighlighterSheets } from './highlight-sheets'

/**
 * Hook to get the correct diff highlighter implementation based on platform
 */
export function useDiffHighlighter() {
  const platform = usePlatform()

  return useMemo(
    () => (platform === 'excel' ? diffHighlighterExcel : diffHighlighterSheets),
    [platform]
  )
}
